<template>
    <div v-if="isreadshow">
        <my-search @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.bdname"  placeholder="标段名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time">

            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="edit()">添加</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="异常编号" prop="yccode" min-width="220" fixed></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode"></el-table-column>
            <el-table-column label="提交时间" prop="tjtime"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj==='6'">
                        <my-tag type="primary" v-if="scope.row.by5==='1'">交易中心待审核</my-tag>
                        <my-tag type="primary" v-else>待推送</my-tag>
                    </div>
                     <push-type 
                        :column="scope.row" 
                        :pushPage="'ycgg'" 
                        :primaryKey="scope.row.yccode"
                        :procode="getQuery('procode')">
                    </push-type>
                    <my-tag type="success" v-if="scope.row.shbj==='9'">已发布</my-tag>
                    <div v-if="scope.row.shbj==='3'">
                        <my-tag  type="danger">退回</my-tag>
                        <div style="margin-top:10px;">
                            退回原因：{{scope.row.by4}}
                        </div>
                    </div>
                    <my-tag v-if="scope.row.shbj==='0'" type="warning">未提交</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj==='0'||scope.row.shbj==='3'">
                        <my-btn type="edit" @click="edit(scope.row.yccode)">修改</my-btn>
                        <my-btn type="del" @click="del(scope.row.yccode)">删除</my-btn>
                    </div>
                    <div v-if="scope.row.shbj==='6'||scope.row.shbj==='9'">
                        <my-btn type="detail" @click="detail(scope.row.yccode)">详情</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/Zbzz/ZbYcZz/yclist.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import PushType from '@/components-sys/push-type'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType
    },
    data() {
        return{
            pgData:{
                procode:'',
                sortname : 'yccode',              
            },
            form:{

            },
            isreadshow:true
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //删除
        del:function(id){
            var that=this;         
            that.$post(`${this.getGetters('bidUrl')}/Zbzz/ZbYcZz/del.json`,{yccode:id,oper:'del'}, (data, res) => {
                ShowMsg('删除成功', 'success')
                that.reload()
            }); 
        },
        //详情
        detail:function(yccode){
            this.goto({
                path:'./detail',
                query:{
                    yccode:yccode
                }
            });
        },
        //修改
        edit:function(yccode){
            this.goto({
                path:'./form',
                query:{
                    procode:this.pgData.procode,
                    yccode:yccode
                }
            });
        }
    },
    created() {
        if(this.$route.query.procode!==undefined){
            this.pgData.procode=this.$route.query.procode
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
